import { useCallback, useEffect, useRef, useState } from 'react';

export function useAutohideScrollbar(hideDelayMs = 700) {
  const [isScrollbarVisible, setIsScrollbarVisible] = useState(false);
  const hideTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current !== null) {
        window.clearTimeout(hideTimeoutRef.current);
      }
    };
  }, []);

  const onScroll = useCallback(() => {
    setIsScrollbarVisible(true);

    if (hideTimeoutRef.current !== null) {
      window.clearTimeout(hideTimeoutRef.current);
    }

    hideTimeoutRef.current = window.setTimeout(() => {
      setIsScrollbarVisible(false);
    }, hideDelayMs);
  }, [hideDelayMs]);

  const className = [
    'liks-scrollbar',
    'liks-scrollbar--autohide',
    isScrollbarVisible && 'liks-scrollbar--visible',
  ]
    .filter(Boolean)
    .join(' ');

  return { className, onScroll };
}
